import { createStore } from 'vuex';

import userModule from './modules/user/index';
import programModule from '@/store/modules/program/index.js';
import eodModule from '@/store/modules/eod/index.js';
import selfCheckInModule from '@/store/modules/selfcheckin/index.js';

const store = createStore({
  modules: {
    user: userModule,
    program: programModule,
    eod: eodModule,
    selfcheckin: selfCheckInModule,
  }
});

export default store;
